module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-15.04c05341.png";